export default __webpack_public_path__ + "static/media/Location_Thuringen.3396be7d.svg";